/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as handlers from "../../../../UserManagement/_redux/users/usersHandlers"
import cogoToast from "cogo-toast";
import { debounce, permissionCssClass, ucFirst } from "../../../../../util/Helpers";
import { SearchBar } from "../../SearchBar";
import { AsideMenu } from "../AsideMenu";
import { UserIcon } from "../../../../../util/Icons"
import { Link } from "react-router-dom";
import { Permission } from "../../Permission";
import { Permissions, PermissionType } from "../../../../../util/Permissions";

export const UsersMenu = () => {
    const users = useSelector(({ users }) => users, shallowEqual);
    const dispatch = useDispatch();

    /* User Search Input */
    const searchUser = e => {
        const query = e.target.value.trim();
        if (query !== "") {
            dispatch(handlers.searchUsers(query));
        }
    }
    /* Notification Pop up */
    useEffect(() => {
        if (users.notification) {
            cogoToast[users.notification.type](users.notification.message);
            dispatch(handlers.clearNotification());
        }
    });

    return (
        <div className="d-flex flex-column h-100">
            <SearchBar
                placeholder={"Search Users"}
                isLoading={users?.isLoading}
                onInput={debounce(searchUser, 1000)}
            />

            <div className="h-100 overflow-auto">
                {
                    users.data.map((user, i) => (
                        <AsideMenu.NavItem to={`/users/view/${user.userId}`} key={i}>
                            <div className="d-flex align-items-center">
                                <div
                                    style={{
                                        height: "28px",
                                        width: "28px",
                                    }}
                                    className="mr-3 border rounded-circle bg-black d-flex align-items-center justify-content-center"
                                >
                                    <UserIcon size="18px" />
                                </div>
                                <div className="col px-0 flex-column align-items-start">
                                    <div>
                                        {`${user.firstName} ${user.lastName}`.substring(0, 20)}
                                    </div>
                                    <div>
                                        {user.email.substr(0, 20)}
                                    </div>
                                    <div className="text-muted">
                                        =&gt; {ucFirst(user.userGroup?.substring(0, 20))}
                                    </div>
                                </div>
                            </div>
                        </AsideMenu.NavItem>
                    ))
                }
            </div>

            <Permission permission={Permissions.PROFILE} permissionType={PermissionType.CREATE}>
                <div className="bg-white border-top px-4">
                    <Link to="/users/create" className={`btn btn-dark w-100 h-40 my-2 my-lg-3`}>
                        Create User
                    </Link>
                </div>
            </Permission>
        </div>
    );
}
